import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Table, { Size } from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../common/EnhancedTableHead';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      tableLayout: 'fixed'
    },
    nameCell: {
      minWidth: 200
    },
    kmsKeyCell: {
      minWidth: 150
    },
    valueCell: {
      wordBreak: 'break-all'
    }
  })
);

interface Props {
  items: any[];
  hideKmsKeyArn?: boolean,
  size?: Size
}

const headRows: HeadRow[] = [
  { id: 'name', disablePadding: false, label: 'Parameter Name' },
  { id: 'value', disablePadding: false, label: 'Parameter Value' }
];

function FaroParametersTable(props: Props) {
  const classes = useStyles({});
  const [order, setOrder] = React.useState<Order>('asc');
  const [orderBy, setOrderBy] = React.useState<string>('name');

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const sortedRows = sortRows(props.items, getSorting(order, orderBy));

  return (
    <TableContainer>
      <Table size={props.size || 'small'} className={classes.table}>
        <EnhancedTableHead
          order={order}
          orderBy={orderBy}
          fields={props.hideKmsKeyArn ? headRows : [...headRows, { id: 'kmsKeyArn', disablePadding: false, label: 'KMS Key ARN' }]}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {sortedRows.map(row => (
            <TableRow key={row.name}>
              <TableCell className={classes.nameCell}>{row.name}</TableCell>
              <TableCell className={classes.valueCell}>{row.value}</TableCell>
              {!props.hideKmsKeyArn && <TableCell className={classes.kmsKeyCell}>{row.kmsKeyArn}</TableCell>}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FaroParametersTable;
